export const IPFS_GATEWAY = process.env.REACT_APP_IPFS_GATEWAY;